import { render, staticRenderFns } from "./ReviewTableAgGridComponent.vue?vue&type=template&id=a54dbaa8&scoped=true&"
import script from "./ReviewTableAgGridComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewTableAgGridComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTableAgGridComponent.vue?vue&type=style&index=0&id=a54dbaa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54dbaa8",
  null
  
)

export default component.exports